export default __webpack_public_path__ + "static/media/TF3-1.df259a24.jpg";